/*
 * IMPORTS
 */
import { gql } from '@apollo/client' // Npm: Apollo client for handling graphql request.


/*
 * GRAPHS
 */
const Index = gql`
query RouteReadQuery($routeId: ID!) {
  RouteRead(routeId: $routeId) {
    id,
    displayName,
    type,
    RoutePlan {
      id,
      isPaused,
      Mcc {
        id,
        mcc,
        Mnc {
          id,
          mnc
        }
      }
      Mnc {
        id,
        network,
        mnc
      }
      Sms {
        id,
        createdAt,
        updatedAt,
        message,
        isUnicodeMessage,
        deliveredThrough,
        status
      }
      VendorAccount {
        id,
        Smpp {
          id,
          ip,
          rxPort,
          txPort,
          username
        }
      }
    }
  }
}
`


/*
 * EXPORTS
 */
export default Index
